export default __webpack_public_path__ + "static/media/56.67b171ec.jpeg";